import { useNavigate } from '@exam-management/router';
import { PaperSection, type PaperSectionProps } from '@shared/components';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { QuestionListDataGrid } from '../../components';
import { useQuestionReviewTaskDetails } from '../../providers';

import { mapQuestionsToQuestionRows } from './utils';

interface QuestionListProps {
  endAdornment?: PaperSectionProps['endAdornment'];
}

export default function QuestionList(props: Readonly<QuestionListProps>) {
  const { endAdornment } = props;
  const { questions, taskDetails } = useQuestionReviewTaskDetails();
  const location = useLocation();

  const navigate = useNavigate();

  const rows = useMemo(
    () => mapQuestionsToQuestionRows(questions, taskDetails.id, location.pathname),
    [questions, taskDetails.id, location.pathname],
  );

  return (
    <PaperSection
      title='Question List'
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        overflow: 'hidden',
      })}
      endAdornment={endAdornment}
    >
      <QuestionListDataGrid
        rows={rows}
        onRowClick={({ row }) => {
          navigate(row.goToPath, {
            params: {
              questionId: row.questionId,
              taskId: row.taskId,
            },
          });
        }}
      />
    </PaperSection>
  );
}
